import i18next from 'i18next';

import i18n from '../../i18n';
import actionTypes from '../constants/action-types';
import loadExtensionTranslations from '../helpers/load-extension-translations';
import getExtensions from '../selectors/extensions';

const translationsLoader = (store) => (next) => (action) => {
  switch (action.type) {
    case i18n.actionTypes.SET_LOCALE: {
      const { locale } = action.payload;
      const extensions = getExtensions(store.getState());

      if (i18next.language === locale) {
        next(action);
        break;
      }

      extensions.forEach((extension) => {
        if (extension.version) {
          loadExtensionTranslations(extension, locale);
        }
      });
      next(action);
      break;
    }
    case actionTypes.REGISTER_EXTENSION: {
      const { extension } = action.payload;
      // we do not need to load translations for editors inner extensions
      if (!extension.version) {
        next(action);
        return;
      }
      const locale = i18n.selectors.getLocale(store.getState());
      loadExtensionTranslations(action.payload.extension, locale).then(() => next(action));
      break;
    }
    default:
      next(action);
  }
};

export default translationsLoader;
